import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import CodeHuntImg from "../../assets/event-images/code-hunt.png";

const codeHunt = {
  image: CodeHuntImg,
  description:
    "A fun game of technical treasure hunt where the players have to solve each level to reach the treasure. The game contains 3 major levels.",
  type: "Technical Event",
  eventName: "Code Hunt",
  dateTime: "Mar 01, 11:00AM - 12:30PM",
  venue: "IT-215",
  rules: [
    "Each team must consist of 3-4 members.",
    "Round 1 - Escape Code: Teams must solve coding problems to escape from the prison. The first teams to escape will gain an advantage in Round 2.",
    "Round 2 - Divide & Conquer: Teams must solve the clues and recombine their information to uncover the final destination address. Participants will be tested on their logical thinking & problem-solving skills.",
    "Round 3 - Gold Rush: The final round will consist of a series of rapid-fire questions testing logic, programming skills, and problem-solving abilities. The team that answers the most questions correctly wins the treasure. In case of a tie, a final sudden-death question will decide the winner.",
    "The event will consist of 3 levels with increasing difficulty.",
    "Each team must solve the challenge and follow clues to progress to the next level.",
    "Unethical practices such as cheating by electronic/human/internet means won’t be appreciated & necessary actions will be taken."
],

  firstprize: 1000,
  secondprize: 500,
  thirdprize: 0,
  contact: [
    {
      name: "Nilesh",
      phoneNo: "9994390896",
    },
    {
      name: "Vishnu Aravind",
      phoneNo: "9003814322",
    },
  ],
};

const CodeHunt = () => {
  return <SingleEventPage eventDetails={codeHunt} />;
};

export default CodeHunt;
